import { ulid } from 'ulid';
import { useTranslation } from 'react-i18next';
import { IMessageQuickCheckInResponseOption } from '../types';

export function useDefaultMessageQuickResponses(): IMessageQuickCheckInResponseOption[] {
  const { t: tMessaging } = useTranslation('inAppMessaging');

  return [
    {
      id: ulid(),
      value: tMessaging('quick-check-in-response-option-one'),
    },
    {
      id: ulid(),
      value: tMessaging('quick-check-in-response-option-two'),
    },
    {
      id: ulid(),
      value: tMessaging('quick-check-in-response-option-three'),
    },
  ] as const;
}
